export default "__VITE_ASSET__8017f8e8__"